<template>
  <router-view />
  <confirm-modal />
  <offline-banner />
</template>

<script setup>
  import { inject, watch } from 'vue'
  import { useRouter } from 'vue-router'
  import { useHead } from '@unhead/vue'

  import { useAuthStore } from 'src/stores/auth'
  import { useMetadataStore } from 'src/stores/account/metadata'
  import { useDynamicMetaData } from 'src/composables/app/system/useDynamicMetaData'

  import { isNotFoundLocation, ROUTES } from 'src/router/const'

  import ConfirmModal from 'components/common/ConfirmModal.vue'
  import OfflineBanner from 'components/common/OfflineBanner.vue'

  const auth0 = inject('auth0')
  const router = useRouter()
  const authStore = useAuthStore()
  const metadataStore = useMetadataStore()

  useDynamicMetaData()

  useHead(() => metadataStore.metaTags)

  watch(
    () => auth0.isAuthenticated.value,
    (isAuthenticated) => {
      if (!isAuthenticated || isNotFoundLocation(router)) return
      const redirectRoute = authStore.redirectRoute || '/' + ROUTES.APP
      authStore.setRedirectRoute(null)
      if (redirectRoute === router.currentRoute.value.fullPath) return
      router.replace(redirectRoute)
    }
  )

  watch(
    () => auth0.isLoading.value,
    (isLoading, wasLoading) => {
      if (
        !wasLoading ||
        isLoading ||
        auth0.isAuthenticated.value ||
        authStore.isLoggingOut ||
        authStore.isRedirectingToAuthRouter ||
        isNotFoundLocation(router)
      ) {
        return
      }
      authStore.login()
    }
  )
</script>

<style lang="scss">
  .auth-loading-overlay {
    position: fixed;
    inset: 0;
    z-index: 6000;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: theme-color('background-light');
  }
</style>
